export default __webpack_public_path__ + "static/media/updated-ISCO.f1f5b0c4.pdf";